import React from 'react';
import styled from 'styled-components';

const FAQContainer = styled.div`
  margin-bottom: var(--spacing-lg);
`;

const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md);
  background-color: ${props => props.isOpen ? 'var(--light-bg)' : 'var(--white)'};
  border: 1px solid var(--light-bg);
  border-radius: ${props => props.isOpen ? 'var(--border-radius-md) var(--border-radius-md) 0 0' : 'var(--border-radius-md)'};
  cursor: pointer;
  transition: all var(--transition-fast);
  
  &:hover {
    background-color: var(--light-bg);
  }
`;

const FAQQuestion = styled.h3`
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
`;

const FAQIcon = styled.span`
  color: var(--primary);
  font-size: var(--font-size-lg);
  transition: transform var(--transition-fast);
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
`;

const FAQContent = styled.div`
  padding: ${props => props.isOpen ? 'var(--spacing-md)' : '0'};
  max-height: ${props => props.isOpen ? '1000px' : '0'};
  overflow: hidden;
  transition: all var(--transition-normal);
  border: ${props => props.isOpen ? '1px solid var(--light-bg)' : 'none'};
  border-top: none;
  border-radius: 0 0 var(--border-radius-md) var(--border-radius-md);
`;

const FAQAnswer = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.6;
  
  p {
    margin-bottom: var(--spacing-md);
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  ul, ol {
    margin-bottom: var(--spacing-md);
    padding-left: var(--spacing-lg);
  }
`;

const FAQ = ({ question, answer, isOpen = false, toggleFAQ }) => {
  return (
    <FAQContainer>
      <FAQHeader isOpen={isOpen} onClick={toggleFAQ}>
        <FAQQuestion>{question}</FAQQuestion>
        <FAQIcon isOpen={isOpen}>▼</FAQIcon>
      </FAQHeader>
      <FAQContent isOpen={isOpen}>
        <FAQAnswer>
          {typeof answer === 'string' ? <p>{answer}</p> : answer}
        </FAQAnswer>
      </FAQContent>
    </FAQContainer>
  );
};

export default FAQ;
